import { useEffect, useState } from 'react';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import SearchBtn from '../../../component/common/button/SearchBtn';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';
import { useShallow } from 'zustand/shallow';
import useModalStore from '../../../zustand/store/useModalStore';
import { useIs17Inch } from '../../../hooks/useBreakPoint';
import { FocusTrap } from 'focus-trap-react';

import '../../../css/modal.css'

// beforeSelect(emog): 선택을 누를 때 부른다(선택). false 로 끝나면 기관을 넣지 않고 창도 닫지 않는다
const EmogSearch_layer = ({setSelectEmog, setUpdateEmog, beforeSelect}) => {

    // 기관 검색 modal
    const [emogSearchLayerOpen, setEmogSearchLayerOpen] = useModalStore(useShallow((state) => [state.emogSearchLayerOpen, state.setEmogSearchLayerOpen]));

    // 승인 전 사용자는 어느 기관으로든 옮길 수 있어(가입 때 잘못 고른 기관 수정) J003 관리자도 센터구분 · 지역을 고른다.
    // 지역은 필수라 J003 은 본인 지역을 미리 골라 둔다. 옮길 수 있는 기관인지는 저장할 때 서버가 확인한다
    const paramsInit = {
        searchGrdc: '',
        searchLoca: localStorage.getItem("userAuth") === 'J003' ? (localStorage.getItem("emogloca") || '') : '',
        searchEmog: '',
        validationCheckList: ['searchLoca']
    }
    
    const [searchParams, setSearchParams] = useState(paramsInit);
    
    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['NO', '기관명', '주소'];
    const dataColumn = ['SEQ', 'EMOGDESC', 'ADDRROAD'];
    const apiCall = '/commonapi/selectOrgList.do';
    const apiCntCall = '';
    const excelFileName = '';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead, 
        dataColumn: dataColumn, 
        apiCall: apiCall, 
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['10%', '35%', '55%'],
        wrapTF: true
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        loadingHeight: '6rem'
    })
    
    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    // cell onClick
    const [selectRow, setSelectRow] = useState();
    const [pickedEmog, setPickedEmog] = useState();
    const selectCellParams = ['EMOGCODE', 'EMOGDESC'];

    const handleOnClick = (dataList, index, selectCellParams, key) => {
        const emog = {
            emogcode: dataList[index][selectCellParams[0]],
            emogdesc: dataList[index][selectCellParams[1]]
        };
        setSelectEmog(emog);
        setPickedEmog(emog);
        setSelectRow(key);
    };

    // 데이터 수정 후 re search
    const [reSearch, setReSearch] = useState(false);
    // 엔터 이벤트 추가
    const activeEnter = (e) => {
        if(e.key === 'Enter') {
            setReSearch(true);
        }
    }

    // 기관 검색 모달 닫기 시 결과 초기화
    const onClickClose = () => {
        setSearchParams(paramsInit);
        setSelectRow();
        setPickedEmog();
        setState(prev => ({
            ...prev,
            dataList: [],
            isSearched: false,
        }));
        setPageInfo(prev => ({
            ...prev,
            totalItems: 0,
        }));
        setEmogSearchLayerOpen(false);
    }
    // 기관 선택 함수
    const onClickSelect = async () => {
        if (beforeSelect && !(await beforeSelect(pickedEmog))) return;
        setUpdateEmog(true);
        onClickClose();
    }

    // esc 키 누르면 모달 닫히는 기능 (확인/알림창이 떠 있을 때는 그 창만 닫히도록 무시)
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key !== 'Escape') return;
            const { confirmModal, notiModal, promptModal } = useModalStore.getState();
            if (confirmModal || notiModal || promptModal) return;
            onClickClose();
        };
    
        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleEscape);
    
        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClickClose]);

    const is17Inch = useIs17Inch();

    return (
        <>
            {emogSearchLayerOpen && 
                <FocusTrap>
                    <div className='layer_container emog_layer'>
                        <div className='layer_wrapper'>
                            <div className={`modal_title_box ${is17Inch ? 'mb-2' : 'mb-6'}`}>
                                <h4>기관 검색</h4>
                            </div>
                            <div className='com-search'>
                                <table>
                                    <colgroup>
                                        <col width='11%' />
                                        <col width='23%' />
                                        <col width='10%' />
                                        <col width='23%' />
                                        <col width='10%' />
                                        <col width='23%'/>
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <NewCommonSelect
                                                hospitalTF={false}
                                                searchParams={searchParams}
                                                handleInputChange={handleInputChange}
                                                lockOwnOrg={false}
                                            />
                                            <th>기관명</th>
                                            <td>
                                                <input type='text' className='input_style' name='searchEmog' onChange={handleInputChange} onKeyDown={(e) => activeEnter(e)}/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <SearchBtn
                                propsInfo={propsInfo}
                                state={state}
                                setState={setState}
                                searchParams={searchParams}
                                searchParamsAdditional={searchParamsAdditional}
                                pageInfo={pageInfo}
                                setPageInfo={setPageInfo}
                                reSearch={reSearch}
                                setReSearch={setReSearch}
                                lockOwnOrg={false}
                            />
                            <NewDataGrid
                                propsInfo={propsInfo}
                                state={state}
                                pageInfo={pageInfo}
                                setPageInfo={setPageInfo}
                                selectCellParams={selectCellParams}
                                handleOnClick={handleOnClick}
                                selectRow={selectRow}
                            />
                            <hr className='mb-5'/>
                            <div className='modal_btn_box'>
                                <button className={`modal_btn ${selectRow ? 'bg_ho_primary' : 'bg_co_light'}`} disabled={!selectRow} onClick={() => onClickSelect()}>선택</button>
                                <button className='modal_btn bg_co_black' onClick={onClickClose}>닫기</button>
                            </div>
                        </div>
                    </div>
                </FocusTrap>
            }
        </>
    )
}

export default EmogSearch_layer